import React from "react";
import ReactDOM from "react-dom";
import "./assets/css/vendor/bootstrap.min.css";
import "./assets/css/vendor/bootstrap.rtl.only.min.css";
import "react-toastify/dist/ReactToastify.css";
import App from "./App";

ReactDOM.render(<App />, document.getElementById("root"));
